import { COLOR } from '../constants';

export const Colors = {
  red: COLOR.RED,
  black: COLOR.BLACK,
  white: COLOR.WHITE,
  background: COLOR.ORANGEBG,
};
